export default "__VITE_ASSET__ChxUhbGh__"